
import axios from "axios";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import EventTile from "./EventTile";

import { useLocalStorage } from "../../hooks";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../redux/reducers/dashboardReducer";


import { TabPanel } from "@headlessui/react";
import noEventImage from "../../assets/noEventImage.svg";
import { TwButton, TwContainer, TwMainLayout, TwTabContainer } from "../../components/tailwind";
import TwAutocomplete from "../../components/tailwind/TwAutocomplete";
import { useToast } from "../../provider/ToastProvider";
import { setSectionLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import { getUrlForEvent } from "../../utils/confighelpers";
import { useTranslation } from "react-i18next";

export default function EventList({ navigation, profileFor, title }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dashboardReduxState = useSelector(dashboardState);
  const [userToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const [loading, setLoading] = React.useState(false);
  const [searchVal, setSearchValues] = React.useState('');
  const [tabCurrentState, setTabCurrentState] = React.useState('1');
  const [classList, setClassList] = React.useState([]);
  const [isNoClassAvailable, setIsNoClassAvailable] = React.useState({
    all: true,
    published: true,
    drafts: true,
    cancelled: true,
  });
  React.useEffect(() => {
    (async () => {
      dispatch(setSectionLoading(true));
      await getListOfClass();
      dispatch(setSectionLoading(false));
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken, dashboardReduxState.updateSessionComp]);


  const handleSessionClick = async (id, eventData) => {
    dispatch(dashboardActions.setCalendarClassData(eventData));
    dispatch(dashboardActions.setCalendarSessionId(id));
    dispatch(dashboardActions.setCalendarSessionData({ eventId: eventData, allEventSchedules: eventData.allEventSchedules }));
    dispatch(dashboardActions.setViewSessionPage(true));
    navigate("/myevents/detail");


    //   }
    // }
  };

  const getListOfClass = async () => {
    let mgClasses = [];
    const manageClassesConfig = {
      method: "get",
      url: `${getUrlForEvent()}list?listFor=${userReduxState.businessType}`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const manageClassesRequest = await axios(manageClassesConfig);
    if (manageClassesRequest.status === 200) {
      if (manageClassesRequest.data.data.length) {
        for (const item of manageClassesRequest.data.data) {
          mgClasses.push({
            label: item.eventName,
            id: item._id,
            data: item
          });
        }
        setClassList(mgClasses);
      }
    }
  };

  const renderClasses = (data, tab = "all") => {
    // setIsNoClassAvailable(true)
    return (
      <div>
        {data.length > 0 ? (
          data.slice(0).reverse().map((item, idx) => {
            const modifiedData = {
              id: item.data._id,
              imgSrc: item.data.eventPhoto,
              name: item.data.eventName,
              rating: item.data.rating,
              bookingRevenue: item.data.totalBookings.totalRevenue,
              seatsBooked: item.data.totalBookings.totalConfirmedBooking,
              popover: true,
              popoverLine: item.data.isPackage,
              insideDetailView: true,
              classDetail: item.data,
            };

            let isDisplay = false;
            if (
              tab === "all"
              || (tab === "published" && item.data.hasOwnProperty("isPublic") && item.data.isPublic === true)
              || (tab === "drafts" && item.data.hasOwnProperty("isPublic") && item.data.isPublic === false)
              || (tab === "cancelled" && item.data.hasOwnProperty("isDeleted") && item.data.isDeleted === true)
            ) {
              if (isNoClassAvailable[tab]) {
                setIsNoClassAvailable({
                  ...isNoClassAvailable,
                  [tab]: false
                })
              }
              isDisplay = true;
            }
            return (isDisplay) ? (
              <div
                key={idx}
                className={"cursor-pointer"}
              // onClick={() => handleSessionClick(modifiedData.id, item)}
              >
                <EventTile
                  {...modifiedData}
                  key={idx}
                  handleSessionClick={() => {
                    handleSessionClick(modifiedData.id, item.data);
                  }}
                  reloadData={async () => {
                    await getListOfClass();
                  }}
                />
              </div>
            ) : "";
          })
        ) : (
          <div className={"text-black"}>no events are available</div>
        )}
      </div>
    );
  };

  const onSearchClickHandle = async (eventData) => {
    const config = {
      method: "get",
      // url: `${getUrlForEvent()}list?searchclass=${newDate}&eventId=${eventData.id}`,
      url: `${getUrlForEvent()}list?searchclass=${eventData.label}&listFor=${userReduxState.businessType}`,
      headers: {
        "x-access-token": userToken.toString(),
      },
    };
    const manageClassesRequest = await axios(config);
    let mgClasses = [];
    if (manageClassesRequest.status === 200) {
      if (manageClassesRequest.data.data.length) {
        for (const item of manageClassesRequest.data.data) {
          mgClasses.push({
            label: item.eventName,
            id: item._id,
            data: item
          });
        }
        setClassList(mgClasses);
      }
    }
  };


  return (
    <TwMainLayout
      headTitle={title}
      children={
        <TwContainer className=""  >

          {classList.length ? (<div
            className={"grid grid-cols-2 w-full px-3 pt-5"}
          >
            <div className={"flex flex-col justify-center [items-center]"}>
              <TwAutocomplete
                options={classList}
                value={searchVal}
                onChange={(even, newValue) => {
                  if (newValue) {
                    setSearchValues(newValue.label);
                    onSearchClickHandle(newValue);
                  } else {
                    setSearchValues("");
                    onSearchClickHandle({ label: "", id: "", data: {} });
                  }
                }}
              />
              <div className="w-full">
                <TwTabContainer
                  className=""
                  tabsClassName="border-b px-5 md:px-10"
                  selectedTab={"all"}
                  tabs={[
                    {
                      name: t("myschedule.allTab"), key: 'all', onClick: () => { }, icon: null,

                    },
                    {
                      name: t("myschedule.publishedTab"), key: 'published', onClick: () => { }, icon: null,
                    },
                    {
                      name: t("myschedule.draftsTab"), key: 'drafts', onClick: () => { }, icon: null,
                    },
                    {
                      name: t("myschedule.cancelledtab"), key: 'cancelled', onClick: () => { }, icon: null,
                    },
                  ]}>
                  <TabPanel value="all" sx={{ p: 2 }}>
                    <div className={`self-start px-3`}>
                      {renderClasses(classList, "all")}
                      {(isNoClassAvailable["all"]) ? (<div className={"text-black text-center"}>no events are available</div>) : ""}
                    </div>
                  </TabPanel>
                  <TabPanel value="published">
                    <div className={`self-start px-3`}>
                      {renderClasses(classList, "published")}
                      {(isNoClassAvailable["published"]) ? (<div className={"text-black text-center"}>no events are available</div>) : ""}
                    </div>
                  </TabPanel>
                  <TabPanel value="drafts">
                    <div className={`self-start px-3`}>
                      {renderClasses(classList, "drafts")}
                      {(isNoClassAvailable["drafts"]) ? (<div className={"text-black text-center"}>no events are available</div>) : ""}
                    </div>
                  </TabPanel>
                  <TabPanel value="cancelled"><div className={`self-start px-3`}>
                    {renderClasses(classList, "cancelled")}
                    {(isNoClassAvailable["cancelled"]) ? (<div className={"text-black text-center"}>no events are available</div>) : ""}
                  </div></TabPanel>
                </TwTabContainer>
              </div>
            </div>
            <div className={"flex justify-end items-top"}>
              <div className={"flex-col items-end mr-28"}>
                <TwButton
                  variant={"secondary"}
                  className={"lg:hidden "}
                  onClick={() => {
                    navigate("/myevents/new");
                  }}
                >
                  {t("pageTitle.addNewEvent")}
                </TwButton>
              </div>
            </div>
          </div>) : loading === false ? (
            <div className="flex flex-col justify-center items-center gap-5 text-center h-full">
              <img
                className={"w-40 md:w-60"}
                src={noEventImage}
                alt={""}
              />
              <div className={"text-secondary text-lg font-bold"}>
                {t("myschedule.noEventsConfigured")}
              </div>
              <div className="flex justify-center items-center w-full">
                <TwButton
                  variant={"secondary"}
                  className={"lg:hidden "}
                  onClick={() => {
                    // setNewDraftEventData({});
                    navigate("/myevents/new");
                  }}
                >
                  {t("myEvents.addNewEvent")}
                </TwButton>
              </div>
            </div>
          ) : ""}
        </TwContainer>} />
  );
}
